import React, { useState } from 'react'

import clsx from 'clsx'

import { IconButton } from 'components/Button'
import Grid, { Container } from 'components/Grid'
import Icon from 'components/Icon'
import CompareBasket from 'components/Layout/components/HeaderCompareBasket'
import Search from 'components/Search'
import SiteMenus from 'components/SiteMenus'
import UserDrawer from 'components/UserDrawer'
import { useAppContext } from 'context/AppContext'
import { EventContext, useEventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'

import LogoGASVG from './LogoGASVG.webp'

import classes from './AppBar.module.scss'

/** @type {import('./types').default} */
const AppBar = ({ user, hideBasket = false }) => {
  const [showSearch, setShowSearch] = useState(false)
  const { addEvent } = useEventContext()
  const { is, down, up } = useViewport()
  const { isCypressTakingSnapshots } = useAppContext()

  return (
    <header
      data-testid="app-bar"
      className={clsx('AppBar', classes.root, { [classes.withSticky]: !isCypressTakingSnapshots })}
    >
      <Container component={Grid} container className={clsx(classes.content, showSearch && classes.contentWithSearch)}>
        <Grid
          item
          lg={2}
          md={3}
          xs={showSearch ? 2 : 7}
          className={clsx(classes.menuLeft, {
            [classes.hidden]: showSearch,
          })}
        >
          {down('md') && <UserDrawer user={user} className={classes.burgerMenu} />}
          <a
            {...addEvent({
              engagementComponent: 'header',
              engagementDestination: 'go-to_home',
              engagementDetails: 'logo_getapp',
              name: 'engagement_navigation',
            })}
            href="/"
            aria-label="getapp-logo-link"
            className={clsx(classes.logoAnchor, {
              [classes.hidden]: showSearch,
            })}
          >
            <img src={LogoGASVG.src} alt="getapp-logo" className={classes.logo} />
          </a>
        </Grid>
        <Grid item xs={showSearch ? 10 : 5} sm={5} md={6} lg={5} className={classes.search}>
          <div className={clsx(classes.fullWidth, classes.mobileSearch)}>
            {showSearch ? (
              <Search focusOnDisplay onBlur={() => setShowSearch(false)} colorVariant="dark" />
            ) : (
              <IconButton data-testid="search-icon" size="small" onClick={() => setShowSearch(true)}>
                <Icon icon={['fas', 'search']} size="24" className={classes.searchIcon} />
              </IconButton>
            )}
          </div>

          {up('sm') && (
            <div className={classes.fullWidth}>
              <div className={classes.desktopSearchContainer}>
                <div className={classes.desktopSearch}>
                  <EventContext value={{ name: 'engagement_cta_compare' }}>
                    <Search colorVariant="dark" />
                  </EventContext>
                </div>
                {!hideBasket && !is('sm') && <CompareBasket />}
              </div>
            </div>
          )}
        </Grid>
        {up('md') && (
          <Grid item md={3} lg={5} className={classes.menuRight}>
            <SiteMenus user={user} />
          </Grid>
        )}
      </Container>
    </header>
  )
}

export default AppBar
